'use strict';

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */

function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append(
            '<div class="contact-us-signup-message"></div>'
        );
    }
    $('.contact-us-signup-message')
        .append('<div class="contact-us-signup-alert text-center ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.contact-us-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

var send = function(form, token){
    var button = $('.subscribe-contact-us');
    var url = Urls.CONTACTUS_ACTION_URL;
    var firstName = $('#contact-first-name').val();
    var lastName = $('#contact-last-name').val();
    var email = $('#contact-email').val();
    var phone = $('#contact-tel').val();
    var subject = $('#contact-topic').val();
    var comment = $('#contact-comment').val();
    var params = {
        contactFirstName: firstName,
        contactLastName: lastName,
        contactEmail: email,
        contactTel: phone,
        contactTopic: subject,
        contactComment: comment,
        recaptchaToken: token
    };
    $.spinner().start();
    button.attr('disabled', true);
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: params,
        success: function (data) {
            displayMessage(data, button);
            if (data.success) {
                $('.contact-us').trigger('reset');
            }
        },
        error: function (err) {
            displayMessage(err, button);
        }
    });
     
}


var baseSubscribeContact = require('base/contactUs/contactUs');

baseSubscribeContact.subscribeContact = function () {
    $('form.contact-us').submit(function (e) {
        var form = $(this);
        e.preventDefault();

        grecaptcha.ready(function() {
            grecaptcha.execute(sitePreferences.RECAPTCHA_PUBLUC_SITE_KEY, {action: 'submit'}).then(function(token) {
                send(form, token);
            });
        });
    })
};
module.exports =  baseSubscribeContact.subscribeContact



